import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import API from '../../api/api'
import Avatar from '../../Avatar'

import { getTrainingType } from './../../helpers/helpers'
import Icon from './../Icons'

class CancelPopup extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.handleCancelOne = this.handleCancelOne.bind(this)
    this.handleCancelAllFollowing = this.handleCancelAllFollowing.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
    this.state = {
      cancelPending: false,
      cancelAllPending: false,
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.clickHandler)
    window.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27) {
      this.handleClose()
    }
  }

  clickHandler(e) {
    const className = $(e.target).attr('class')
    if (className && className.trim() === 'ctp-cancel-popup') {
      this.handleClose()
    }
  }
  handleClose(_e) {
    this.props.onUpdate('', null)
  }

  handleCancelOne(_e) {
    const { training } = this.props
    this.setState({ cancelPending: true })
    API.signToTraining(training.id)
      .then(() => {
        this.props.onUpdate('cancel-confirmation', training, true)
      })
      .catch((error) => {
        throw new Error(error)
      })
  }

  handleCancelAllFollowing() {
    const { training } = this.props
    this.setState({ cancelAllPending: true })
    API.signToTraining(training.id, true)
      .then(() => {
        this.props.onUpdate('cancel-confirmation', training, true)
      })
      .catch((error) => {
        throw new Error(error)
      })
  }

  render() {
    const { cancelPending, cancelAllPending } = this.state
    const repeats = !!this.props.training.gid
    const trainingType = getTrainingType(this.props.training)
    return (
      <div className="ctp-cancel-popup">
        <div className="ctp-cancel-popup-window">
          <div className="ctp-cancel-popup-window__header">
            <h1> What would you like to do ? </h1>
            <div className="ctp-cancel-popup-window__close" onClick={this.handleClose}>
              <Icon icon="cross" />
            </div>
          </div>
          <div className="ctp-cancel-popup-window__body">
            <div
              className={`ctp-section ctp-section-content ${cancelPending ? 'is-loading' : ''}`}
              onClick={this.handleCancelOne}
            >
              <Avatar>
                <Icon icon="calendar" />
              </Avatar>
              <div className={`ctp-section`}>
                <div className="ctp-title">Cancel this one class</div>
                <div className="ctp-detail">All other instances of this class will remain.</div>
              </div>
            </div>
            {repeats && (
              <div
                className={`ctp-section ctp-section-content ${
                  cancelAllPending ? 'is-loading' : ''
                }`}
                onClick={this.handleCancelAllFollowing}
              >
                <div className="ctp-avatar">
                  <Icon icon="calendarMultiple" />
                </div>
                <div className={'ctp-section'}>
                  <div className="ctp-title">Cancel all following</div>
                  <div className="ctp-detail">
                    This and all following classes will be cancelled.
                  </div>
                </div>
              </div>
            )}
            {trainingType === 'event' && (
              <div className="ctp-row">
                <p className="ctp-title">
                  If you cancel the lesson less than 24 hours before it starts, the funds will not
                  be returned.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

CancelPopup.propTypes = {
  training: PropTypes.object,
  onUpdate: PropTypes.func,
}

export default CancelPopup
